'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.EFirmwareType = void 0;
(function (EFirmwareType) {
    EFirmwareType["Universal"] = "universal";
    EFirmwareType["BitcoinOnly"] = "bitcoinonly";
})(exports.EFirmwareType || (exports.EFirmwareType = {}));

function fillStringWithArguments(value, object) {
    if (typeof value !== 'string')
        return value;
    if (value.indexOf('{') === -1)
        return value;
    let result = '';
    let i = 0;
    const dict = object;
    while (i < value.length) {
        const open = value.indexOf('{', i);
        if (open === -1) {
            result += value.slice(i);
            break;
        }
        const close = value.indexOf('}', open + 1);
        if (close === -1) {
            result += value.slice(i);
            break;
        }
        result += value.slice(i, open);
        const key = value.slice(open + 1, close);
        if (key.length === 0) {
            result += '{}';
        }
        else {
            const replacement = dict[key];
            result += replacement ? String(replacement) : '?';
        }
        i = close + 1;
    }
    return result;
}
class HardwareError extends Error {
    constructor(hardwareError) {
        var _a;
        super();
        this.errorCode = HardwareErrorCode.UnknownError;
        this.message = '';
        this.params = {};
        const errorMessageMapping = HardwareErrorCodeMessage;
        this.message = errorMessageMapping[HardwareErrorCode.UnknownError];
        if (typeof hardwareError === 'string') {
            this.errorCode = HardwareErrorCode.UnknownError;
            this.message = hardwareError;
        }
        else {
            const message = (_a = (hardwareError.message || errorMessageMapping[hardwareError.errorCode])) !== null && _a !== void 0 ? _a : '';
            if (message) {
                this.message = fillStringWithArguments(message, hardwareError);
            }
            this.params = hardwareError.params;
            this.errorCode = hardwareError.errorCode;
        }
        this.name = 'HardwareError';
    }
}
const HardwareErrorCode = {
    UnknownError: 0,
    DeviceFwException: 101,
    DeviceUnexpectedMode: 102,
    DeviceListNotInitialized: 103,
    SelectDevice: 104,
    DeviceNotFound: 105,
    DeviceInitializeFailed: 106,
    DeviceInterruptedFromOutside: 107,
    RequiredButInBootloaderMode: 108,
    DeviceInterruptedFromUser: 109,
    DeviceCheckDeviceIdError: 110,
    DeviceNotSupportPassphrase: 111,
    DeviceCheckPassphraseStateError: 112,
    DeviceNotOpenedPassphrase: 113,
    DeviceOpenedPassphrase: 114,
    DeviceDetectInBootloaderMode: 115,
    NotAllowInBootloaderMode: 116,
    DeviceBusy: 117,
    DeviceCheckUnlockTypeError: 118,
    NotInitialized: 200,
    IFrameNotInitialized: 300,
    IFrameAleradyInitialized: 301,
    IFrameLoadFail: 302,
    IframeTimeout: 303,
    IframeBlocked: 304,
    IframeDistrust: 305,
    CallMethodError: 400,
    CallMethodNotResponse: 404,
    CallMethodInvalidParameter: 405,
    FirmwareUpdateDownloadFailed: 406,
    CallMethodNeedUpgradeFirmware: 407,
    CallMethodDeprecated: 408,
    FirmwareUpdateLimitOneDevice: 409,
    FirmwareUpdateManuallyEnterBoot: 410,
    FirmwareUpdateAutoEnterBootFailure: 411,
    NewFirmwareUnRelease: 412,
    UseDesktopToUpdateFirmware: 413,
    NewFirmwareForceUpdate: 414,
    DeviceNotSupportMethod: 415,
    ForbiddenKeyPath: 416,
    RepeatUnlocking: 417,
    DefectiveFirmware: 418,
    NetworkError: 500,
    TransportNotConfigured: 600,
    TransportCallInProgress: 601,
    TransportNotFound: 602,
    TransportInvalidProtobuf: 603,
    BleScanError: 700,
    BlePermissionError: 701,
    BleLocationError: 702,
    BleRequiredUUID: 703,
    BleConnectedError: 704,
    BleDeviceNotBonded: 705,
    BleServiceNotFound: 706,
    BleCharacteristicNotFound: 707,
    BleMonitorError: 708,
    BleCharacteristicNotifyError: 709,
    BleWriteCharacteristicError: 710,
    BleAlreadyConnected: 711,
    BleLocationServicesDisabled: 712,
    BleTimeoutError: 713,
    BleForceCleanRunPromise: 714,
    BleDeviceBondError: 715,
    BleCharacteristicNotifyChangeFailure: 716,
    BleTransportCallCanceled: 717,
    BleDeviceBondedCanceled: 718,
    BlePeerRemovedPairingInformation: 719,
    BleDeviceDisconnected: 720,
    BlePoweredOff: 721,
    BleUnsupported: 722,
    BleUnavailableWhileUsbConnected: 723,
    BleBondInvalid: 724,
    RuntimeError: 800,
    PinInvalid: 801,
    PinCancelled: 802,
    ActionCancelled: 803,
    FirmwareError: 804,
    ResponseUnexpectTypeError: 805,
    BridgeNetworkError: 806,
    BridgeTimeoutError: 807,
    BridgeNotInstalled: 808,
    PollingTimeout: 809,
    PollingStop: 810,
    BlindSignDisabled: 811,
    UnexpectPassphrase: 812,
    FileAlreadyExists: 813,
    CheckDownloadFileError: 814,
    NotInSigningMode: 815,
    DataOverload: 816,
    BridgeDeviceDisconnected: 817,
    BTCPsbtTooManyUtxos: 818,
    EmmcFileWriteFirmwareError: 819,
    FirmwareVerificationFailed: 820,
    BridgeNeedsPermission: 821,
    CallQueueActionCancelled: 822,
    FirmwareDowngradeNotAllowed: 823,
    CosmosInvalidJsonMessage: 824,
    DeviceSettingsNotProvided: 825,
    DeviceSettingsLanguageNotSupport: 826,
    TooManyInputs: 827,
    PinMismatch: 828,
    DeviceLocked: 830,
    WalletSessionInvalid: 831,
    NftStorageLimitReached: 832,
    LowlevelTrasnportConnectError: 900,
    WebDeviceNotFoundOrNeedsPermission: 901,
    WebDevicePromptAccessError: 902,
};
const HardwareErrorCodeMessage = {
    [HardwareErrorCode.UnknownError]: 'Unknown error occurred. Check message property.',
    [HardwareErrorCode.DeviceFwException]: 'Firmware version mismatch',
    [HardwareErrorCode.DeviceUnexpectedMode]: 'Device unexpected mode',
    [HardwareErrorCode.DeviceListNotInitialized]: 'Device list is not initialized',
    [HardwareErrorCode.SelectDevice]: 'Please select the connected device',
    [HardwareErrorCode.DeviceNotFound]: 'Device not found',
    [HardwareErrorCode.DeviceInitializeFailed]: 'Device initialization failed',
    [HardwareErrorCode.DeviceInterruptedFromOutside]: 'Device interrupted',
    [HardwareErrorCode.DeviceInterruptedFromUser]: 'Device interrupted',
    [HardwareErrorCode.RequiredButInBootloaderMode]: 'Device should be in bootloader mode',
    [HardwareErrorCode.DeviceCheckDeviceIdError]: 'The connected device does not match this wallet. Reconnect the correct device, or add it again after a reset or recovery.',
    [HardwareErrorCode.DeviceNotSupportPassphrase]: 'Device not support passphrase',
    [HardwareErrorCode.DeviceCheckPassphraseStateError]: 'Device passphrase state error',
    [HardwareErrorCode.DeviceNotOpenedPassphrase]: 'Device not opened passphrase',
    [HardwareErrorCode.DeviceOpenedPassphrase]: 'Device opened passphrase',
    [HardwareErrorCode.DeviceDetectInBootloaderMode]: 'Device in bootloader mode',
    [HardwareErrorCode.NotAllowInBootloaderMode]: 'Device not allow in bootloader mode',
    [HardwareErrorCode.DeviceBusy]: 'Device is busy',
    [HardwareErrorCode.DeviceCheckUnlockTypeError]: 'The unlocked wallet does not match the selected wallet. Use the corresponding PIN or passphrase and try again.',
    [HardwareErrorCode.NotInitialized]: 'Not initialized',
    [HardwareErrorCode.IFrameNotInitialized]: 'IFrame not initialized',
    [HardwareErrorCode.IFrameAleradyInitialized]: 'IFrame alerady initialized',
    [HardwareErrorCode.IFrameLoadFail]: 'IFrame load fail',
    [HardwareErrorCode.IframeTimeout]: 'init iframe time out',
    [HardwareErrorCode.IframeBlocked]: 'IFrame blocked',
    [HardwareErrorCode.IframeDistrust]: 'IFrame host not trust',
    [HardwareErrorCode.CallMethodError]: 'Runtime errors during method execution',
    [HardwareErrorCode.CallMethodNotResponse]: 'Method does not responding',
    [HardwareErrorCode.CallMethodInvalidParameter]: 'Call method invalid parameter',
    [HardwareErrorCode.FirmwareUpdateDownloadFailed]: 'Firmware update download failed',
    [HardwareErrorCode.CallMethodNeedUpgradeFirmware]: 'Call method need upgrade firmware',
    [HardwareErrorCode.CallMethodDeprecated]: 'Call method is deprecated',
    [HardwareErrorCode.FirmwareUpdateLimitOneDevice]: 'Only one device can be connected during firmware upgrade',
    [HardwareErrorCode.FirmwareUpdateManuallyEnterBoot]: 'You need to manually enter boot',
    [HardwareErrorCode.FirmwareUpdateAutoEnterBootFailure]: 'Description Failed to automatically enter boot',
    [HardwareErrorCode.NewFirmwareUnRelease]: 'new firmware has not been released yet',
    [HardwareErrorCode.NewFirmwareForceUpdate]: 'new firmware has been released, please update',
    [HardwareErrorCode.UseDesktopToUpdateFirmware]: 'Please use OneKey desktop client to update the firmware',
    [HardwareErrorCode.DeviceNotSupportMethod]: 'Device not support this method',
    [HardwareErrorCode.ForbiddenKeyPath]: 'Forbidden key path',
    [HardwareErrorCode.RepeatUnlocking]: 'Repeat unlocking',
    [HardwareErrorCode.DefectiveFirmware]: 'Device firmware is defective, please update immediately',
    [HardwareErrorCode.NetworkError]: 'Network request error',
    [HardwareErrorCode.TransportNotConfigured]: 'Transport not configured',
    [HardwareErrorCode.TransportCallInProgress]: 'Transport call in progress',
    [HardwareErrorCode.TransportNotFound]: 'Transport not found',
    [HardwareErrorCode.TransportInvalidProtobuf]: 'Transport invalid protobuf',
    [HardwareErrorCode.BleScanError]: 'BLE scan error',
    [HardwareErrorCode.BlePermissionError]: 'Bluetooth required to be turned on',
    [HardwareErrorCode.BleLocationError]: 'Location permissions for the application are not available',
    [HardwareErrorCode.BleRequiredUUID]: 'uuid is required',
    [HardwareErrorCode.BleConnectedError]: 'connected error is always runtime error',
    [HardwareErrorCode.BleDeviceNotBonded]: 'device is not bonded',
    [HardwareErrorCode.BleDeviceBondedCanceled]: 'device is canceled bonding',
    [HardwareErrorCode.BlePeerRemovedPairingInformation]: 'need to delete pairing information',
    [HardwareErrorCode.BleServiceNotFound]: 'BLEServiceNotFound: service not found',
    [HardwareErrorCode.BleCharacteristicNotFound]: 'BLEServiceNotFound: service not found',
    [HardwareErrorCode.BleMonitorError]: 'Monitor Error: characteristic not found',
    [HardwareErrorCode.BleCharacteristicNotifyError]: 'Characteristic Notify Error',
    [HardwareErrorCode.BleWriteCharacteristicError]: 'Write Characteristic Error',
    [HardwareErrorCode.BleAlreadyConnected]: 'Already connected to device',
    [HardwareErrorCode.BleLocationServicesDisabled]: 'Location Services disabled',
    [HardwareErrorCode.BleTimeoutError]: 'The connection has timed out unexpectedly.',
    [HardwareErrorCode.BleForceCleanRunPromise]: 'Force clean Bluetooth run promise',
    [HardwareErrorCode.BleDeviceBondError]: 'Bluetooth pairing failed',
    [HardwareErrorCode.BleCharacteristicNotifyChangeFailure]: 'Characteristic Notify Change Failure',
    [HardwareErrorCode.BleTransportCallCanceled]: 'Ble Transport call canceled',
    [HardwareErrorCode.BleDeviceDisconnected]: 'Device disconnected',
    [HardwareErrorCode.BlePoweredOff]: 'Bluetooth is turned off',
    [HardwareErrorCode.BleUnsupported]: 'Bluetooth is not supported on this device',
    [HardwareErrorCode.BleUnavailableWhileUsbConnected]: 'Bluetooth is unavailable while USB is connected. Unplug USB and try again.',
    [HardwareErrorCode.BleBondInvalid]: 'Bluetooth pairing information is no longer valid. Forget the device in system Bluetooth settings and pair it again.',
    [HardwareErrorCode.RuntimeError]: 'Runtime error',
    [HardwareErrorCode.PinInvalid]: 'Pin invalid',
    [HardwareErrorCode.PinCancelled]: 'Pin cancelled',
    [HardwareErrorCode.ActionCancelled]: 'Action cancelled by user',
    [HardwareErrorCode.CallQueueActionCancelled]: 'Action cancelled by user on call queue',
    [HardwareErrorCode.FirmwareError]: 'Firmware installation failed',
    [HardwareErrorCode.ResponseUnexpectTypeError]: 'Response type is not expected',
    [HardwareErrorCode.BridgeNetworkError]: 'Bridge network error',
    [HardwareErrorCode.BridgeTimeoutError]: 'Bridge network timeout',
    [HardwareErrorCode.BridgeNotInstalled]: 'Bridge not installed',
    [HardwareErrorCode.BridgeDeviceDisconnected]: 'Bridge device disconnected during action',
    [HardwareErrorCode.PollingTimeout]: 'Polling timeout',
    [HardwareErrorCode.PollingStop]: 'Polling stop',
    [HardwareErrorCode.BlindSignDisabled]: 'Please confirm the BlindSign enabled',
    [HardwareErrorCode.UnexpectPassphrase]: 'Unexpect passphrase',
    [HardwareErrorCode.FileAlreadyExists]: 'File already exists',
    [HardwareErrorCode.CheckDownloadFileError]: 'Check download file error',
    [HardwareErrorCode.NotInSigningMode]: 'not in signing mode',
    [HardwareErrorCode.DataOverload]: 'Params data overload',
    [HardwareErrorCode.BTCPsbtTooManyUtxos]: 'PSBT too many utxos',
    [HardwareErrorCode.EmmcFileWriteFirmwareError]: 'EMMC file write firmware error',
    [HardwareErrorCode.FirmwareVerificationFailed]: 'Firmware verification failed',
    [HardwareErrorCode.BridgeNeedsPermission]: 'Bridge needs permission',
    [HardwareErrorCode.FirmwareDowngradeNotAllowed]: 'Firmware downgrade not allowed',
    [HardwareErrorCode.CosmosInvalidJsonMessage]: 'Cosmos invalid JSON message, Only support Amino msgs.',
    [HardwareErrorCode.DeviceSettingsNotProvided]: 'No setting provided',
    [HardwareErrorCode.DeviceSettingsLanguageNotSupport]: 'Language not supported',
    [HardwareErrorCode.TooManyInputs]: 'Too many inputs',
    [HardwareErrorCode.PinMismatch]: 'PIN mismatch',
    [HardwareErrorCode.DeviceLocked]: 'Device locked',
    [HardwareErrorCode.WalletSessionInvalid]: 'Wallet session is invalid or expired',
    [HardwareErrorCode.NftStorageLimitReached]: 'NFT storage limit reached. Remove an NFT from the device and try again.',
    [HardwareErrorCode.LowlevelTrasnportConnectError]: 'Lowlevel transport connect error',
    [HardwareErrorCode.WebDeviceNotFoundOrNeedsPermission]: 'Web-USB or Web-Bluetooth device not found or needs permission',
    [HardwareErrorCode.WebDevicePromptAccessError]: 'Web-USB or Web-Bluetooth device prompt access error',
};
const TypedError = (hardwareError, message, params) => {
    if (typeof hardwareError === 'string') {
        return new HardwareError(hardwareError);
    }
    return new HardwareError({ errorCode: hardwareError, message: message !== null && message !== void 0 ? message : '', params });
};
const isBleStaleBondHardwareError = (error) => {
    const code = error === null || error === void 0 ? void 0 : error.errorCode;
    return (code === HardwareErrorCode.BleDeviceBondError ||
        code === HardwareErrorCode.BlePeerRemovedPairingInformation ||
        code === HardwareErrorCode.BleBondInvalid);
};
const isBleStaleBondErrorText = (text) => {
    const value = text.toLowerCase();
    return (value.includes('encryption is insufficient') ||
        value.includes('insufficient encryption') ||
        value.includes('peer removed pairing information') ||
        value.includes('cberrordomain:14') ||
        value.includes('gatt_insuf_authentication'));
};
const serializeError = (payload) => {
    if (payload && payload.error instanceof HardwareError) {
        return {
            error: payload.error.message,
            code: payload.error.errorCode,
            params: payload.error.params,
        };
    }
    if (payload && payload.error && payload.error.name === 'AxiosError') {
        return { error: payload.error.message, code: HardwareErrorCode.BridgeNetworkError };
    }
    if (payload && payload.error instanceof Error) {
        return { error: payload.error.message, code: payload.error.code };
    }
    return payload;
};
const CreateErrorByMessage = (message) => {
    for (const code of Object.values(HardwareErrorCode)) {
        if (HardwareErrorCodeMessage[code] === message) {
            return TypedError(code);
        }
    }
    return new HardwareError(message);
};
const CreateHardwareErrorByBridgeError = (raw) => {
    const msg = String(raw || '');
    if (msg.includes('LIBUSB_ERROR_ACCESS')) {
        return TypedError(HardwareErrorCode.BridgeNeedsPermission, 'LIBUSB_ERROR_ACCESS');
    }
    return TypedError(HardwareErrorCode.BridgeNetworkError, msg);
};
const createNewFirmwareUnReleaseHardwareError = ({ currentVersion, requireVersion, methodName, firmwareType, }) => {
    if ((methodName === null || methodName === void 0 ? void 0 : methodName.startsWith('btc')) === false && firmwareType === exports.EFirmwareType.BitcoinOnly) {
        return createDeviceNotSupportMethodError(methodName !== null && methodName !== void 0 ? methodName : '', firmwareType);
    }
    const methodInfo = methodName ? ` for method '${methodName}'` : '';
    return TypedError(HardwareErrorCode.NewFirmwareUnRelease, `Device firmware version is too low${methodInfo}, please update to the latest version`, { current: currentVersion, require: requireVersion, method: methodName });
};
const createNeedUpgradeFirmwareHardwareError = ({ currentVersion, requireVersion, methodName, firmwareType, }) => {
    if ((methodName === null || methodName === void 0 ? void 0 : methodName.startsWith('btc')) === false && firmwareType === exports.EFirmwareType.BitcoinOnly) {
        return createDeviceNotSupportMethodError(methodName !== null && methodName !== void 0 ? methodName : '', firmwareType);
    }
    const methodInfo = methodName ? ` for method '${methodName}'` : '';
    return TypedError(HardwareErrorCode.CallMethodNeedUpgradeFirmware, `Device firmware version is too low${methodInfo}, please update to ${requireVersion}`, { current: currentVersion, require: requireVersion, method: methodName });
};
const createNewFirmwareForceUpdateHardwareError = (connectId, deviceId, versionTypes, currentVersions) => {
    const types = versionTypes || [];
    const typeMap = { firmware: 'firmware', ble: 'BLE firmware' };
    const requiredTypes = types.filter(type => type in typeMap);
    const getVersionInfo = () => {
        const versions = [];
        if (currentVersions === null || currentVersions === void 0 ? void 0 : currentVersions.firmware)
            versions.push(`firmware version: ${currentVersions.firmware}`);
        if (currentVersions === null || currentVersions === void 0 ? void 0 : currentVersions.ble)
            versions.push(`BLE version: ${currentVersions.ble}`);
        return versions.length > 0 ? ` (${versions.join(', ')})` : '';
    };
    const getTypeDescription = () => requiredTypes.map(type => typeMap[type]).join(' and ');
    const message = `Device ${getTypeDescription()} version is too low. ${getVersionInfo()}`;
    return TypedError(HardwareErrorCode.NewFirmwareForceUpdate, message, {
        connectId,
        deviceId,
        versionTypes,
        currentVersions,
    });
};
const createDeprecatedHardwareError = (currentVersion, deprecatedVersion, methodName) => {
    const methodInfo = methodName ? ` Method '${methodName}'` : 'This method';
    return TypedError(HardwareErrorCode.CallMethodDeprecated, `Device firmware version is too high. ${methodInfo} has been deprecated in ${deprecatedVersion}`, { current: currentVersion, deprecated: deprecatedVersion, method: methodName });
};
const createDefectiveFirmwareError = (serialNo, seVersion, deviceType, connectId, deviceId) => {
    const message = `Defective firmware detected (Serial: ${serialNo}, SE: ${seVersion}). Please update immediately.`;
    return TypedError(HardwareErrorCode.DefectiveFirmware, message, {
        serialNo,
        seVersion,
        deviceType,
        connectId,
        deviceId,
    });
};
const createDeviceNotSupportMethodError = (methodName, firmwareType) => TypedError(HardwareErrorCode.DeviceNotSupportMethod, `Device not support this method`, {
    firmwareType: firmwareType.toString(),
    method: methodName,
});

var HardwareError$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    HardwareError: HardwareError,
    HardwareErrorCode: HardwareErrorCode,
    HardwareErrorCodeMessage: HardwareErrorCodeMessage,
    TypedError: TypedError,
    isBleStaleBondHardwareError: isBleStaleBondHardwareError,
    isBleStaleBondErrorText: isBleStaleBondErrorText,
    serializeError: serializeError,
    CreateErrorByMessage: CreateErrorByMessage,
    CreateHardwareErrorByBridgeError: CreateHardwareErrorByBridgeError,
    createNewFirmwareUnReleaseHardwareError: createNewFirmwareUnReleaseHardwareError,
    createNeedUpgradeFirmwareHardwareError: createNeedUpgradeFirmwareHardwareError,
    createNewFirmwareForceUpdateHardwareError: createNewFirmwareForceUpdateHardwareError,
    createDeprecatedHardwareError: createDeprecatedHardwareError,
    createDefectiveFirmwareError: createDefectiveFirmwareError,
    createDeviceNotSupportMethodError: createDeviceNotSupportMethodError
});

const HARDWARE_CONNECT_PROTOCOL = {
    V1: 'V1',
    V2: 'V2',
};
const ONEKEY_WEBUSB_FILTER = [
    { vendorId: 0x1209, productId: 0x53c0 },
    { vendorId: 0x1209, productId: 0x53c1 },
    { vendorId: 0x1209, productId: 0x4f4a },
    { vendorId: 0x1209, productId: 0x4f4b },
    { vendorId: 0x1209, productId: 0x4f4c },
];
const ONEKEY_PROTOCOL_V2_USB_IDS = [{ vendorId: 0x1209, productId: 0x4f4c }];
const TREZOR_WEBUSB_MANUFACTURER_NAMES = new Set(['trezor', 'trezor company', 'satoshilabs']);
const isKnownTrezorWebUsbDevice = (descriptor) => {
    var _a;
    const isSharedWebUsbId = ONEKEY_WEBUSB_FILTER.some(filter => descriptor.vendorId === filter.vendorId && descriptor.productId === filter.productId);
    if (!isSharedWebUsbId)
        return false;
    const manufacturerName = (_a = descriptor.manufacturerName) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase();
    return manufacturerName != null && TREZOR_WEBUSB_MANUFACTURER_NAMES.has(manufacturerName);
};
const ERROR_CODES_REQUIRE_RELEASE = [
    HardwareErrorCode.DeviceInitializeFailed,
    HardwareErrorCode.DeviceInterruptedFromOutside,
    HardwareErrorCode.DeviceInterruptedFromUser,
    HardwareErrorCode.DeviceCheckPassphraseStateError,
    HardwareErrorCode.ResponseUnexpectTypeError,
    HardwareErrorCode.PinInvalid,
    HardwareErrorCode.PinCancelled,
    HardwareErrorCode.UnexpectPassphrase,
];
const ERROR_CODES_REQUIRE_DISCONNECT = [
    HardwareErrorCode.DeviceInitializeFailed,
    HardwareErrorCode.ResponseUnexpectTypeError,
];
exports.EOneKeyBleMessageKeys = void 0;
(function (EOneKeyBleMessageKeys) {
    EOneKeyBleMessageKeys["BLE_SELECT"] = "$onekey-ble-select";
    EOneKeyBleMessageKeys["BLE_SELECT_RESULT"] = "$onekey-ble-select-result";
    EOneKeyBleMessageKeys["BLE_STOP_SCAN"] = "$onekey-ble-stop-scan";
    EOneKeyBleMessageKeys["BLE_CANCEL_REQUEST"] = "$onekey-ble-cancel-request";
    EOneKeyBleMessageKeys["BLE_PRE_SELECT"] = "$onekey-ble-pre-select";
    EOneKeyBleMessageKeys["BLE_CLEAR_PRE_SELECT"] = "$onekey-ble-clear-pre-select";
    EOneKeyBleMessageKeys["BLE_PAIRING_REQUEST"] = "$onekey-ble-pairing-request";
    EOneKeyBleMessageKeys["BLE_PAIRING_RESPONSE"] = "$onekey-ble-pairing-response";
    EOneKeyBleMessageKeys["BLE_ENUMERATE"] = "$onekey-ble-enumerate";
    EOneKeyBleMessageKeys["BLE_ENUMERATE_RESULT"] = "$onekey-ble-enumerate-result";
    EOneKeyBleMessageKeys["BLE_DEVICE_DISCONNECTED"] = "$onekey-ble-device-disconnected";
    EOneKeyBleMessageKeys["BLE_AVAILABILITY_CHECK"] = "$onekey-ble-availability-check";
    EOneKeyBleMessageKeys["NOBLE_BLE_ENUMERATE"] = "$onekey-noble-ble-enumerate";
    EOneKeyBleMessageKeys["NOBLE_BLE_STOP_SCAN"] = "$onekey-noble-ble-stop-scan";
    EOneKeyBleMessageKeys["NOBLE_BLE_GET_DEVICE"] = "$onekey-noble-ble-get-device";
    EOneKeyBleMessageKeys["NOBLE_BLE_CONNECT"] = "$onekey-noble-ble-connect";
    EOneKeyBleMessageKeys["NOBLE_BLE_RELEASE"] = "$onekey-noble-ble-release";
    EOneKeyBleMessageKeys["NOBLE_BLE_DISCONNECT"] = "$onekey-noble-ble-disconnect";
    EOneKeyBleMessageKeys["NOBLE_BLE_WRITE"] = "$onekey-noble-ble-write";
    EOneKeyBleMessageKeys["NOBLE_BLE_SUBSCRIBE"] = "$onekey-noble-ble-subscribe";
    EOneKeyBleMessageKeys["NOBLE_BLE_UNSUBSCRIBE"] = "$onekey-noble-ble-unsubscribe";
    EOneKeyBleMessageKeys["NOBLE_BLE_NOTIFICATION"] = "$onekey-noble-ble-notification";
    EOneKeyBleMessageKeys["NOBLE_BLE_MTU_CHANGED"] = "$onekey-noble-ble-mtu-changed";
    EOneKeyBleMessageKeys["NOBLE_BLE_CANCEL_PAIRING"] = "$onekey-noble-ble-cancel-pairing";
})(exports.EOneKeyBleMessageKeys || (exports.EOneKeyBleMessageKeys = {}));
exports.EBleDisconnectReason = void 0;
(function (EBleDisconnectReason) {
    EBleDisconnectReason["DeviceDisconnected"] = "device-disconnected";
    EBleDisconnectReason["IdleKeepAlive"] = "idle-keep-alive";
})(exports.EBleDisconnectReason || (exports.EBleDisconnectReason = {}));
const ONEKEY_SERVICE_UUID = '00000001-0000-1000-8000-00805f9b34fb';
const ONEKEY_WRITE_CHARACTERISTIC_UUID = '00000002-0000-1000-8000-00805f9b34fb';
const ONEKEY_NOTIFY_CHARACTERISTIC_UUID = '00000003-0000-1000-8000-00805f9b34fb';
const MESSAGE_TOP_CHAR = 63;
const MESSAGE_HEADER_BYTE = 35;
const isHeaderChunk = (chunk) => {
    if (chunk.length < 9)
        return false;
    const [MagicQuestionMark, sharp1, sharp2] = chunk;
    if (String.fromCharCode(MagicQuestionMark) === String.fromCharCode(MESSAGE_TOP_CHAR) &&
        String.fromCharCode(sharp1) === String.fromCharCode(MESSAGE_HEADER_BYTE) &&
        String.fromCharCode(sharp2) === String.fromCharCode(MESSAGE_HEADER_BYTE)) {
        return true;
    }
    return false;
};
const isKnownNonOneKeyDeviceName = (normalizedName) => normalizedName.startsWith('trezor') ||
    normalizedName.startsWith('ledger') ||
    normalizedName.startsWith('nano ') ||
    normalizedName.startsWith('stax') ||
    normalizedName.startsWith('flex');
const ONEKEY_EXACT_SHORT_NAMES = new Set(['s8']);
const isOneKeyShortName = (normalizedName) => {
    if (ONEKEY_EXACT_SHORT_NAMES.has(normalizedName))
        return true;
    if (normalizedName.length !== 5)
        return false;
    const firstChar = normalizedName[0];
    return (firstChar === 'k' || firstChar === 't') && /^\d{4}$/.test(normalizedName.slice(1));
};
const isOnekeyDevice = (name, id) => {
    var _a, _b;
    const normalizedName = (_a = name === null || name === void 0 ? void 0 : name.trim().toLowerCase()) !== null && _a !== void 0 ? _a : '';
    if (isKnownNonOneKeyDeviceName(normalizedName)) {
        return false;
    }
    if ((_b = id === null || id === void 0 ? void 0 : id.startsWith) === null || _b === void 0 ? void 0 : _b.call(id, 'MI')) {
        return true;
    }
    if (!name) {
        return false;
    }
    if (normalizedName.startsWith('onekey') || normalizedName.startsWith('bixinkey'))
        return true;
    if (normalizedName.startsWith('touch ') ||
        normalizedName.startsWith('pro ') ||
        normalizedName.startsWith('pro2') ||
        normalizedName.startsWith('neo')) {
        return true;
    }
    const compactName = compactBleName(normalizedName);
    if (PRO2_COMPACT_NAME_PATTERN.test(compactName) || NEO_COMPACT_NAME_PATTERN.test(compactName)) {
        return true;
    }
    return isOneKeyShortName(normalizedName);
};
const inferProtocolHintFromUsbId = (vendorId, productId) => ONEKEY_PROTOCOL_V2_USB_IDS.some(id => id.vendorId === vendorId && id.productId === productId)
    ? 'V2'
    : undefined;
const resolveOneKeyUsbDevicePath = (device) => {
    var _a, _b, _c, _d;
    const serial = (_a = device.serialNumber) === null || _a === void 0 ? void 0 : _a.trim();
    if (serial)
        return serial;
    if (device.vendorId == null && device.productId == null && !device.productName) {
        return undefined;
    }
    const vendorId = ((_b = device.vendorId) !== null && _b !== void 0 ? _b : 0).toString(16).padStart(4, '0');
    const productId = ((_c = device.productId) !== null && _c !== void 0 ? _c : 0).toString(16).padStart(4, '0');
    const product = ((_d = device.productName) !== null && _d !== void 0 ? _d : 'onekey')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '');
    return `usb-${vendorId}-${productId}-${product || 'onekey'}`;
};
const BLUETOOTH_BASE_UUID_SUFFIX = '00001000800000805f9b34fb';
const normalizeBleUuid = (uuid) => (uuid !== null && uuid !== void 0 ? uuid : '').replace(/-/g, '').toLowerCase();
const createKnownBleUuidAliases = (uuid) => {
    const normalized = normalizeBleUuid(uuid);
    const aliases = new Set([normalized]);
    if (normalized.length !== 32 || !normalized.endsWith(BLUETOOTH_BASE_UUID_SUFFIX)) {
        return aliases;
    }
    const assignedNumber = normalized.slice(0, 8);
    aliases.add(assignedNumber);
    if (assignedNumber.startsWith('0000')) {
        aliases.add(assignedNumber.slice(4));
    }
    return aliases;
};
const matchesKnownBleUuid = (actualUuid, aliases) => aliases.has(normalizeBleUuid(actualUuid));
const ONEKEY_COMMUNICATION_SERVICE_ALIASES = createKnownBleUuidAliases(ONEKEY_SERVICE_UUID);
const FIDO_SERVICE_ALIASES = createKnownBleUuidAliases('0000fffd-0000-1000-8000-00805f9b34fb');
const PRO2_COMPACT_NAME_PATTERN = /^(?:onekey)?pro2[a-f0-9]{4}$/i;
const NEO_COMPACT_NAME_PATTERN = /^(?:onekey)?neo[a-f0-9]{4}$/i;
const FIND_MY_COMPACT_SUFFIXES = [
    'findemy',
    'findem',
    'finde',
    'findmy',
    'findm',
    'find',
    'fin',
];
const COMPLETE_FIND_MY_COMPACT_SUFFIXES = ['findemy', 'findmy'];
const compactBleName = (value) => Array.from(value)
    .filter(character => character !== '-' && character.trim() !== '')
    .join('')
    .toLowerCase();
const getFindMyCompactSuffix = (compactName) => FIND_MY_COMPACT_SUFFIXES.find(candidate => compactName.endsWith(candidate));
const getPro2FindMyBaseLength = (value) => {
    const compactName = compactBleName(value);
    const suffix = getFindMyCompactSuffix(compactName);
    if (!suffix)
        return undefined;
    const compactBaseName = compactName.slice(0, -suffix.length);
    return PRO2_COMPACT_NAME_PATTERN.test(compactBaseName) ? compactBaseName.length : undefined;
};
const isPro2FindMyAdvertisementName = (value) => {
    if (!value)
        return false;
    if (getPro2FindMyBaseLength(value) !== undefined)
        return true;
    const compactName = compactBleName(value);
    const suffix = COMPLETE_FIND_MY_COMPACT_SUFFIXES.find(candidate => compactName.endsWith(candidate));
    if (!suffix)
        return false;
    return compactName.slice(0, -suffix.length).includes('pro2');
};
const normalizePro2FindMyAdvertisementName = (value) => {
    const baseLength = getPro2FindMyBaseLength(value);
    if (baseLength === undefined)
        return value;
    let compactLength = 0;
    for (let index = 0; index < value.length; index += 1) {
        const character = value[index];
        if (character !== '-' && character.trim() !== '') {
            compactLength += 1;
            if (compactLength === baseLength) {
                return value.slice(0, index + 1).trimEnd();
            }
        }
    }
    return value;
};
const canonicalizePro2BleAdvertisementName = (value) => {
    const withoutFindMy = normalizePro2FindMyAdvertisementName(value);
    const compact = compactBleName(withoutFindMy);
    if (!PRO2_COMPACT_NAME_PATTERN.test(compact))
        return withoutFindMy;
    const match = withoutFindMy.match(/^(onekey\s*)?pro\s*2\s*/i);
    if (!match)
        return withoutFindMy;
    const rest = withoutFindMy.slice(match[0].length);
    const prefix = match[1] ? 'OneKey Pro 2' : 'Pro 2';
    return rest ? `${prefix} ${rest}` : prefix;
};
const isSameOnekeyBleName = (left, right) => {
    if (!left || !right)
        return false;
    if (left === right)
        return true;
    return (compactBleName(canonicalizePro2BleAdvertisementName(left)) ===
        compactBleName(canonicalizePro2BleAdvertisementName(right)));
};
const hasOnekeyCommunicationService = (serviceUuids) => (serviceUuids !== null && serviceUuids !== void 0 ? serviceUuids : []).some(uuid => matchesKnownBleUuid(uuid, ONEKEY_COMMUNICATION_SERVICE_ALIASES));
const isPro2FamilyBleName = (value) => {
    if (!value) {
        return false;
    }
    const normalized = value.trim().toLowerCase();
    if (!normalized) {
        return false;
    }
    if (normalized.startsWith('pro2') || normalized.startsWith('neo')) {
        return true;
    }
    const compact = compactBleName(normalized);
    return (PRO2_COMPACT_NAME_PATTERN.test(compact) ||
        NEO_COMPACT_NAME_PATTERN.test(compact) ||
        isPro2FindMyAdvertisementName(value));
};
const isOnekeyBluetoothDevice = ({ id, name, localName, serviceUuids, }) => {
    const advertisedServiceUuids = serviceUuids !== null && serviceUuids !== void 0 ? serviceUuids : [];
    if (hasOnekeyCommunicationService(advertisedServiceUuids)) {
        return true;
    }
    if (isPro2FindMyAdvertisementName(name) || isPro2FindMyAdvertisementName(localName)) {
        return false;
    }
    if (advertisedServiceUuids.some(uuid => matchesKnownBleUuid(uuid, FIDO_SERVICE_ALIASES))) {
        return false;
    }
    return isOnekeyDevice(name !== null && name !== void 0 ? name : null, id) || isOnekeyDevice(localName !== null && localName !== void 0 ? localName : null, id);
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function createDeferred(arg, data) {
    let localResolve = (_t) => { };
    let localReject = (_e) => { };
    let id;
    const promise = new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
        localResolve = resolve;
        localReject = reject;
        if (typeof arg === 'function') {
            try {
                yield arg();
            }
            catch (error) {
                reject(error);
            }
        }
        if (typeof arg === 'string')
            id = arg;
    }));
    return {
        id,
        data,
        resolve: localResolve,
        reject: localReject,
        promise,
    };
}

const wait = (ms) => new Promise(resolve => {
    setTimeout(resolve, ms);
});

exports.EDeviceType = void 0;
(function (EDeviceType) {
    EDeviceType["Unknown"] = "unknown";
    EDeviceType["Classic"] = "classic";
    EDeviceType["Classic1s"] = "classic1s";
    EDeviceType["ClassicPure"] = "classicpure";
    EDeviceType["Mini"] = "mini";
    EDeviceType["Touch"] = "touch";
    EDeviceType["Pro"] = "pro";
    EDeviceType["Pro2"] = "pro2";
    EDeviceType["Neo"] = "neo";
})(exports.EDeviceType || (exports.EDeviceType = {}));

exports.CreateErrorByMessage = CreateErrorByMessage;
exports.CreateHardwareErrorByBridgeError = CreateHardwareErrorByBridgeError;
exports.ERRORS = HardwareError$1;
exports.ERROR_CODES_REQUIRE_DISCONNECT = ERROR_CODES_REQUIRE_DISCONNECT;
exports.ERROR_CODES_REQUIRE_RELEASE = ERROR_CODES_REQUIRE_RELEASE;
exports.HARDWARE_CONNECT_PROTOCOL = HARDWARE_CONNECT_PROTOCOL;
exports.HardwareError = HardwareError;
exports.HardwareErrorCode = HardwareErrorCode;
exports.HardwareErrorCodeMessage = HardwareErrorCodeMessage;
exports.ONEKEY_NOTIFY_CHARACTERISTIC_UUID = ONEKEY_NOTIFY_CHARACTERISTIC_UUID;
exports.ONEKEY_PROTOCOL_V2_USB_IDS = ONEKEY_PROTOCOL_V2_USB_IDS;
exports.ONEKEY_SERVICE_UUID = ONEKEY_SERVICE_UUID;
exports.ONEKEY_WEBUSB_FILTER = ONEKEY_WEBUSB_FILTER;
exports.ONEKEY_WRITE_CHARACTERISTIC_UUID = ONEKEY_WRITE_CHARACTERISTIC_UUID;
exports.TypedError = TypedError;
exports.canonicalizePro2BleAdvertisementName = canonicalizePro2BleAdvertisementName;
exports.createDefectiveFirmwareError = createDefectiveFirmwareError;
exports.createDeferred = createDeferred;
exports.createDeprecatedHardwareError = createDeprecatedHardwareError;
exports.createDeviceNotSupportMethodError = createDeviceNotSupportMethodError;
exports.createKnownBleUuidAliases = createKnownBleUuidAliases;
exports.createNeedUpgradeFirmwareHardwareError = createNeedUpgradeFirmwareHardwareError;
exports.createNewFirmwareForceUpdateHardwareError = createNewFirmwareForceUpdateHardwareError;
exports.createNewFirmwareUnReleaseHardwareError = createNewFirmwareUnReleaseHardwareError;
exports.hasOnekeyCommunicationService = hasOnekeyCommunicationService;
exports.inferProtocolHintFromUsbId = inferProtocolHintFromUsbId;
exports.isBleStaleBondErrorText = isBleStaleBondErrorText;
exports.isBleStaleBondHardwareError = isBleStaleBondHardwareError;
exports.isHeaderChunk = isHeaderChunk;
exports.isKnownTrezorWebUsbDevice = isKnownTrezorWebUsbDevice;
exports.isOnekeyBluetoothDevice = isOnekeyBluetoothDevice;
exports.isOnekeyDevice = isOnekeyDevice;
exports.isPro2FamilyBleName = isPro2FamilyBleName;
exports.isPro2FindMyAdvertisementName = isPro2FindMyAdvertisementName;
exports.isSameOnekeyBleName = isSameOnekeyBleName;
exports.matchesKnownBleUuid = matchesKnownBleUuid;
exports.normalizeBleUuid = normalizeBleUuid;
exports.normalizePro2FindMyAdvertisementName = normalizePro2FindMyAdvertisementName;
exports.resolveOneKeyUsbDevicePath = resolveOneKeyUsbDevicePath;
exports.serializeError = serializeError;
exports.wait = wait;
